import Product from "@system/config/product";
import Helper from "src/support/Helper";

class PayloadMaker {
  config = {};
  method = "POST";
  headers = {};
  url = Product.PRODUCT_LISTING;
  data = {};
  isForAutoSuggest = undefined;
  isProductImageInclude = false;
  processed_data = {
    filter: "",
    isIncludeCount: true,
    search: "*",
    skip: 0,
    top: 10,
    isProductImageInclude: this.isProductImageInclude,
    isSkipFacets: true,
    /* by Hardik Sarodiya
    * Made changes temporary true to false
    * Ticket No: 11999
    */
    // isDesignsRequired: false, // 14567
  };

  constructor(config, isForAutoSuggest,isProductImageInclude) {
    this.isForAutoSuggest = isForAutoSuggest;
    this.isProductImageInclude = isProductImageInclude!=undefined ? isProductImageInclude : false;
    this.config = config;
  }

  process = () => {
    if (this.config.method !== undefined) {
      this.method = this.config.method;
    }
    if (this.config.headers !== undefined) {
      this.headers = this.config.headers;
    }
    if (this.config.data !== undefined) {
      this.data = this.config.data;
    }
    return this;
  };

  run = () => {
    if (this.data.filter !== undefined) {
      this.processed_data.filter = this.data.filter;
    }
    if (this.data.orderby !== undefined) {
      this.processed_data.orderby = this.data.orderby;
    }
    if (this.data.search !== undefined) {
      this.processed_data.search = this.data.search;
    }
    if (this.data.isIncludeCount !== undefined) {
      this.processed_data.isIncludeCount = this.data.isIncludeCount;
    }
    if (this.data.isSkipFacets !== undefined) {
      this.processed_data.isSkipFacets = this.data.isSkipFacets;
    }
    if (this.data.searchColumns !== undefined) {
      this.processed_data.searchColumns = this.data.searchColumns;
    }
    if (this.processed_data.filter !== undefined && this.processed_data.filter === "") {
      this.processed_data.filter = "*";
    }
    if (this.config.data.skip !== undefined) {
      this.processed_data.skip = this.config.data.skip;
    }
    if (this.processed_data.skip !== undefined) {
      let skip = this.processed_data.skip;
      if (skip === null) {
        skip = 0;
      }
      if (!skip) {
        skip = 0;
      }
      if (skip === "") {
        skip = 0;
      }
      if (skip < 0) {
        skip = 0;
      }
      this.processed_data.skip = skip;
    }
    if (this.config.data.top !== undefined) {
      this.processed_data.top = this.config.data.top;
    }

    /**
     * Commented due to set isDesignRequired everytime false for ticket 14567
     * Author: Devanshi Patel
     */
    // if (this.isForAutoSuggest == true) {
    //   this.processed_data.isDesignsRequired = false;
    //   this.processed_data.isProductImageInclude = false;
    // } else
    // PN - 15389 - set IsProductImageInclude flag true only for PDP
    if(this.isProductImageInclude)
    {
      this.processed_data.isProductImageInclude = this.isProductImageInclude
    }
    // if (this.data.isDesignsRequired !== undefined) { // DT - 12May 11177 & 11109 - 4.On Search Call payload, isDesignsRequired should be false.  
    //   this.processed_data.isDesignsRequired = this.data.isDesignsRequired
    // }
    return this;
  };

  get = () => {
    return {
      method: this.method,
      headers: this.headers,
      url: this.url,
      data: this.processed_data,
    };
  };
}

export default PayloadMaker;
